<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M48 20v-9a2 2 0 00-2-2H18a2 2 0 00-2 2v9h-5a2 2 0 00-2 2v31a2 2 0 002 2h42a2 2 0 002-2V22a2 2 0 00-2-2zM34.53 37.49L52 24.62v25.73zM49.2 23l-1.2.82V23zM45 12v14l-13 9.62L19 26V12zM16 23.82L14.8 23H16zm-4 .8L49.2 52H12z"/><path d="M23.86 19h16.28a1 1 0 000-2H23.86a1 1 0 000 2zM23.86 26h16.28a1 1 0 000-2H23.86a1 1 0 000 2z"/></svg>